<template>
  <div class="border-white border-2 overflow-hidden shadow-md rounded-xl">
    <p
      class="
        font-semibold
        flex
        text-gray-800
        tracking-wide
        justify-center
        rounded-t-xl
        bg-gray-50
        p-2
        border-b
      "
    >
      One-Click
      <span class="relative w-6">
        <img
          alt="image"
          src="@/assets/icons/oneclick.svg"
          class="h-6 opacity-60"
        />
        <img
          alt="image"
          src="@/assets/icons/oneclick.svg"
          class="h-4 absolute left-1 top-1 mx-auto animate-ping"
        />
      </span>
      <span> Connect</span>
    </p>
    <div
      class="
        grid grid-cols-5
        bg-white
        justify-items-center
        p-2
        rounded-b-xl
        shadow-md
        overflow-hidden
      "
    >
      <button @click="facebook" aria-label="facebook link">
        <img
          alt="image"
          class="h-7 shadow"
          src="@/assets/social/facebook.png"
        />
      </button>
      <button @click="whatsapp" aria-label="whatsapp link">
        <img
          alt="image"
          class="h-7 shadow"
          src="@/assets/social/whatsapp.png"
        />
      </button>
      <button @click="instagram" aria-label="instagram link">
        <img
          alt="image"
          class="h-8 shadow"
          src="@/assets/social/instagram.png"
        />
      </button>
      <button @click="call" aria-label="phone call link">
        <img alt="image" class="h-7 shadow" src="@/assets/social/phone.png" />
      </button>
      <button @click="google" aria-label="google page link">
        <img alt="image" class="h-7 shadow" src="@/assets/icons/track.svg" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    call() {
      document.location.href = "tel:" + this.$store.state.phone1;
    },
    whatsapp() {
      window.open(this.$store.state.whatsappLink);
    },
    facebook() {
      window.open(this.$store.state.facebookLink);
    },
    instagram() {
      window.open(this.$store.state.instagramLink);
    },
    google() {
      window.open(this.$store.state.googleLink);
    },
  },
};
</script>
